<template>
  <div class="flex w-full gap-x-2.5">
    <div
      v-for="type in types"
      :key="type"
      class="flex flex-1 cursor-pointer flex-col items-center rounded-[12px] border pl-[15px] pr-2.5 py-10 text-center"
      :class="
        type === modelValue
          ? 'border-gray-800 text-gray-800'
          : 'border-[#ebedef] text-gray-600'
      "
      @click="handleClick(type)"
    >
      <component :is="iconFor(type)" class="size-[34px]" />

      <span class="mt-[15px] text-[18px] font-medium leading-[24px]">
        {{ getTitle(type) }}
      </span>

      <span class="mt-1.5 text-[14px] leading-[18px]">
        {{ getDescription(type) }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CopyrightOwnerType } from '@/shared/graphql/legacy/generated'
import { ProfileIcon, OrganizationIcon } from '@dacr/icons'

defineProps<{
  modelValue: CopyrightOwnerType
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', payload: CopyrightOwnerType): void
}>()

const types = [CopyrightOwnerType.Personal, CopyrightOwnerType.Organization]

const iconFor = (type: CopyrightOwnerType) =>
  type === CopyrightOwnerType.Personal ? ProfileIcon : OrganizationIcon

const getTitle = (type: CopyrightOwnerType) =>
  type === CopyrightOwnerType.Personal ? 'Personal' : 'Organization'

const getDescription = (type: CopyrightOwnerType) =>
  type === CopyrightOwnerType.Personal
    ? 'When selected, files added will be owned by this person'
    : 'When selected, files added will be owned by this organization'

const handleClick = (type: CopyrightOwnerType) => {
  emit('update:modelValue', type)
}
</script>
